// Single source of truth for clinic contact + brand strings.
// Update here to propagate site-wide.

export const CLINIC = {
    doctor: {
        fullName: "Dr. Ishani Hanspal",
        credentials: "MBBS, MD, IBLM",
        title: "Lifestyle & Metabolic Medicine Physician",
        tagline: "Lifestyle & Metabolic Medicine",
        // Editorial seated photo — used in the Hero
        photo: "https://customer-assets-agu9un31.emergentagent.net/job_e-commerce-932/artifacts/ied00l7h_Dr%20ishani%20photo.png",
        // Formal head-shot — used in the DoctorIntro / About page
        photoPortrait: "https://customer-assets-agu9un31.emergentagent.net/job_e-commerce-932/artifacts/ie07ebbu_dr%20ishani%20photo%202.jpeg",
    },
    email: "drishanihanspal@gmail.com",
    phone: "+91 8826188890",
    phoneDigits: "918826188890", // for tel: and wa.me links
    cities: ["Chennai", "Gurugram"],
    social: {
        linkedin: "https://www.linkedin.com/in/dr-ishani-hanspal-5833931a4/",
        instagram: "https://www.instagram.com/drishanihanspal",
    },
};

export const buildMailto = (subject, body) => {
    const params = new URLSearchParams();
    if (subject) params.set("subject", subject);
    if (body) params.set("body", body);
    return `mailto:${CLINIC.email}?${params.toString()}`;
};

export const buildWhatsApp = (text) => {
    const encoded = encodeURIComponent(text || "");
    return `https://wa.me/${CLINIC.phoneDigits}?text=${encoded}`;
};
